import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  stream: {},
  entity: {},
  showEntity: false,
  showCategory: false,
  category: {},
  planner: {},
  academicYears: [],
  terms: [],
  blocks: [],
  alumniStreamRecommendations: [],
  advisorStreamRecommendations: [],
  planStreamSearchType: ''
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/index.js